export default class ContextButton {
  constructor (scene, x, y, text, callback) {
    this.scene = scene
    this.callback = callback
    this.textOffsetX = 5
    this.textOffsetY = 20

    var config = {
      fontSize: '20px',
      fontStyle: 'bold'
    }

    this.text = this.scene.add.text(x + this.textOffsetX, y + this.textOffsetY, text, config)
    this.text.setVisible(false)
    this.text.setDepth(1001)

    this.image = this.scene.add.image(x, y, 'white')
    this.image.setOrigin(0, 0)
    this.image.setScale(200, 50)
    this.image.setTint(0xFF0000)
    this.image.setDepth(1000)
    this.image.setInteractive()
    this.image.input.alwaysEnabled = true
    this.image.on('pointerover', () => { this.image.setTint(0xFF7700) })
    this.image.on('pointerout', () => { this.image.setTint(0xFF0000) })
    this.image.on('pointerdown', (pointer, localX, localY, event) => { this.callback() })
  }

  destroy () {
    this.text.destroy()
    this.image.destroy()
  }

  hide () {
    this.text.setVisible(false)
    this.image.setVisible(false)

    this.image.disableInteractive()
  }

  unhide (x, y) {
    this.setX(x)
    this.setY(y)
    this.text.setVisible(true)
    this.image.setVisible(true)

    this.image.setInteractive()
  }

  setX (x) {
    this.text.x = x + this.textOffsetX
    this.image.x = x
  }

  setY (y) {
    this.image.y = y
    this.text.y = y + this.textOffsetY
  }
}
